module.exports = __webpack_public_path__ + "img/sv70.ad3f3dcc.svg";